import React from 'react';
import './HomeButton.css';

/**
 * HomeButtonView — presentational leave-confirm dialog for the persistent
 * home affordance (Issue #1555).
 *
 * #1696 (2026-07-27 DECIDED): the FAB button + tooltip this file used to
 * render moved into the shared FabMenu (components/fabMenu/FabMenu.jsx) —
 * HomeButton.jsx now registers 'home' as a 'menu'-corner FabStack entry
 * (icon/label/onClick) instead of rendering its own fixed-position button.
 * This view is left owning only the confirm dialog, which is unaffected by
 * where the triggering tap came from.
 *
 * Pure (labels + handlers in, markup out) and deliberately free of contexts,
 * router, and i18n so it can be unit-tested with renderToStaticMarkup without
 * jsdom — this workspace has no DOM test env, and importing the container
 * would drag in the context → services → i18n chain that touches `document`
 * at module load. All wiring lives in the HomeButton container.
 */
export default function HomeButtonView({
  labels,
  confirming,
  onConfirmLeave,
  onCancelLeave,
}) {
  if (!confirming) return null;
  return (
    <div
      className="home-button-confirm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="home-button-confirm-title"
      data-html2canvas-ignore="true"
    >
      <div className="home-button-confirm__backdrop" onClick={onCancelLeave} aria-hidden="true" />
      <div className="home-button-confirm__card">
        <h2 id="home-button-confirm-title" className="home-button-confirm__title">
          {labels.confirmTitle}
        </h2>
        <p className="home-button-confirm__body">{labels.confirmBody}</p>
        <div className="home-button-confirm__actions">
          <button
            type="button"
            className="home-button-confirm__btn home-button-confirm__btn--ghost"
            onClick={onCancelLeave}
            autoFocus
          >
            {labels.stay}
          </button>
          <button
            type="button"
            className="home-button-confirm__btn home-button-confirm__btn--primary"
            onClick={onConfirmLeave}
          >
            {labels.leave}
          </button>
        </div>
      </div>
    </div>
  );
}
